(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/button-list.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/button-list.js');
"use strict";


const ButtonList = _ref => {
  let buttonOptions = _ref.buttonOptions,
    sum = _ref.sum;
  const PayButton = svs.tur.ReactPayfooter.PayButton;
  const PrimaryButton = svs.tur.ReactPayfooter.PrimaryButton;
  const SecondaryButton = svs.tur.ReactPayfooter.SecondaryButton;
  const LinkButton = svs.tur.ReactPayfooter.LinkButton;
  const SubmitButton = svs.tur.ReactPayfooter.SubmitButton;
  const ButtonWithDescription = svs.tur.ReactPayfooter.ButtonWithDescription;
  return React.createElement(React.Fragment, null, buttonOptions && Array.isArray(buttonOptions) && buttonOptions.filter(_ref2 => {
    let _ref2$visible = _ref2.visible,
      visible = _ref2$visible === void 0 ? true : _ref2$visible;
    return visible;
  }).map((_ref3, index) => {
    let className = _ref3.className,
      onClick = _ref3.onClick,
      text = _ref3.text,
      primary = _ref3.primary,
      secondary = _ref3.secondary,
      _ref3$transparent = _ref3.transparent,
      transparent = _ref3$transparent === void 0 ? true : _ref3$transparent,
      link = _ref3.link,
      pay = _ref3.pay,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      isSubmit = _ref3.isSubmit,
      formName = _ref3.formName,
      description = _ref3.description;
    const key = "payfooterBtn_".concat(index, "_").concat(text);
    let button;
    if (pay) {
      button = React.createElement(PayButton, {
        className: className,
        disabled: disabled,
        key: key,
        onClick: onClick,
        sum: sum
      });
    } else if (primary) {
      button = React.createElement(PrimaryButton, {
        className: className,
        disabled: disabled,
        key: key,
        onClick: onClick
      }, text);
    } else if (secondary) {
      button = React.createElement(SecondaryButton, {
        className: className,
        disabled: disabled,
        key: key,
        onClick: onClick,
        transparent: transparent
      }, text);
    } else if (link) {
      button = React.createElement(LinkButton, {
        className: className,
        disabled: disabled,
        key: key,
        onClick: onClick
      }, text);
    } else if (isSubmit) {
      button = React.createElement(SubmitButton, {
        className: className,
        disabled: disabled,
        formName: formName,
        isSubmit: isSubmit,
        key: key,
        onClick: onClick
      }, text);
    }
    if (button) {
      if (description) {
        return React.createElement(ButtonWithDescription, {
          button: button,
          description: description,
          key: key
        });
      }
      return button;
    }
    return null;
  }));
};
svs.tur.ReactPayfooter.ButtonList = ButtonList;

 })(window);